/*!
 *
 *  page2top.ts
 *
 */
export default function () {
    var elem = document.getElementById('page2top');
    // const target = <HTMLElement>document.querySelector('.u-target');
    // let borderline = target.getBoundingClientRect().top + target.offsetHeight + window.scrollY;
    function onScroll() {
        var _top = window.pageYOffset;
        if (elem.getAttribute('aria-hidden') === 'true' && _top > 0) {
            elem.setAttribute('aria-hidden', 'false');
        }
        ;
        if (elem.getAttribute('aria-hidden') === 'false' && _top <= 0) {
            elem.setAttribute('aria-hidden', 'true');
        }
        ;
    }
    ;
    // function updateBorderline(): void {
    // 	borderline = target.getBoundingClientRect().top + target.offsetHeight + window.scrollY;
    // };
    onScroll();
    window.addEventListener('scroll', onScroll);
    // window.addEventListener('resize', updateBorderline);
}
